// src/features/providers/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import ProviderType from './pages/providerType/ProviderType';
import ProviderTypeForm from './pages/providerType/ProviderTypeForm';
import MedicalProvider from './pages/medicalProvider/MedicalProvider';
import MedicalProviderForm from './pages/medicalProvider/MedicalProviderForm';
import MedicalProviderBulkForm from './pages/medicalProvider/MedicalProviderBulkForm';
import Detail from './pages/medicalProvider/Detail';
import UserForm from './pages/medicalProvider/UserForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const providersRoute = createRoute({
  getParentRoute: () => rootRoute,
    path: '/providers',
});

export const providersTypeRoute = createRoute({
  getParentRoute: () => providersRoute,
    path: '/provider-type',
    component: ProviderType,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PROVIDERS.SEARCH_PROVIDERTYPE || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const providersTypeFormRoute = createRoute({
    getParentRoute: () => providersRoute,
    path: '/provider-type/form',
    component: ProviderTypeForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PROVIDERS.SAVE_PROVIDERTYPE || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});


export const medicalProviderRoute = createRoute({
    getParentRoute: () => providersRoute,
    path: '/medical-provider',
    component: MedicalProvider,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PROVIDERS.SEARCH_MEDICALPROVIDER || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const medicalProviderFormRoute = createRoute({
    getParentRoute: () => providersRoute,
    path: '/medical-provider/form',
    component: MedicalProviderForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PROVIDERS.SAVE_MEDICALPROVIDER || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const medicalProviderBulkFormRoute = createRoute({
    getParentRoute: () => providersRoute,
    path: '/medical-provider/bulkForm',
    component: MedicalProviderBulkForm,
});

export const ServiceItemPricingFormRoute = createRoute({
    getParentRoute: () => providersRoute,
    path: '/providers/ServiceItemPricingForm',
    component: MedicalProviderBulkForm,
});

export const participantsProviderDetailRoute = createRoute({
    getParentRoute: () => providersRoute,
    path: '/medical-provider/Detail',
    component: Detail,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PROVIDERS.GET_MEDICALPROVIDER_BY_ID || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const medicalProviderUserFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/medical-provider/detail/user',
    component: UserForm,
});

export const providersRoutes = [
    providersRoute,
    providersTypeRoute,
    providersTypeFormRoute,
    medicalProviderRoute,
    medicalProviderFormRoute,
    medicalProviderBulkFormRoute,
    ServiceItemPricingFormRoute,
    participantsProviderDetailRoute,
    medicalProviderUserFormRoute
];